export default __webpack_public_path__ + "icon_battery_with_plug.svg";